import { asMultiStyleConfig } from '../../../../utils/theme';
var parts = ['container', 'groupTitle', 'item', 'itemEmpty'];
var baseStyle = {
  item: {
    '.tqc-radio__label': {
      pl: 4
    }
  }
};
export var Listbox = asMultiStyleConfig({
  parts,
  baseStyle
});